import React from 'react';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import classNames from 'classnames';

/*
https://codesandbox.io/s/react-bootstrapp-checkbox-dropdown-entcq?from-embed=&file=/src/CheckboxDropdown.js
*/

class PopupMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.state.show = false;
	}

	getChildOfType(type) {
		return React.Children.toArray(this.props.children).find((child) => {
			return child.type === type;
		});
	}

	getTrigger() {
		return this.getChildOfType(PopupMenu.Trigger);
	}

	getOverlay() {
		return React.cloneElement(this.getChildOfType(PopupMenu.Overlay), { popup: this });
	}

	show(value) {
		this.setState({ show: value });
	}

	toggle() {
		this.show(!this.state.show);
	}

	renderOverlay(props) {
		var { arrowProps, ...props } = props;

		// Remove arrows
		arrowProps.style = { display: 'none' };
		props.arrowProps = arrowProps;

		return <Popover {...props}>{this.getOverlay()}</Popover>;
	}

	renderTrigger() {
		let onClick = (event) => {
			event.stopPropagation();
		};

		return (
			<div className='d-inline-block' onClick={onClick}>
				{this.getTrigger()}
			</div>
		);
	}

	render() {
		return (
			<OverlayTrigger placement={'bottom-start'} trigger={['click']} show={this.state.show} onToggle={this.toggle.bind(this)} rootClose overlay={this.renderOverlay.bind(this)}>
				{this.renderTrigger()}
			</OverlayTrigger>
		);
	}
}

PopupMenu.Trigger = ({ children, props }) => {
	return <div {...props}>{children}</div>;
};

PopupMenu.Overlay = ({ popup, className, children, ...props }) => {
	children = React.Children.map(children, (child, index) =>
		React.cloneElement(child, {
			popup: popup,
		})
	);

	className = classNames(className, 'px-2');

	return (
		<Dropdown show={true}>
			<Dropdown.Menu {...props} className={className}>
				{children}
			</Dropdown.Menu>
		</Dropdown>
	);
};

PopupMenu.Item = ({ popup, checked, children, ...props }) => {
	let pre = undefined;

	let onClick = () => {
		popup.show(false);
		if (typeof props.onClick == 'function') {
			props.onClick();
		}
	};

	if (checked != undefined) {
		pre = (
			<strong>
				<span className={checked ? 'pe-2 visible' : 'pe-2 invisible'}>✓</span>
			</strong>
		);
	}

	return (
		<Dropdown.Item {...props} onClick={onClick}>
			{pre}
			{children}
		</Dropdown.Item>
	);
};

export default PopupMenu;
